import { motion } from 'framer-motion';
import { REASONS, REVIEWS, VIDEOS } from '@/content/site';

const ease = [0.16, 1, 0.3, 1];

export default function WhyAndReviews() {
  return (
    <section className="py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease }}
        >
          <div className="text-overline mb-7">Why Prép</div>
          <h2 className="font-display text-[1.75rem] sm:text-3xl lg:text-[2.5rem] leading-[1.15] max-w-3xl">
            Why Vancouver clients choose Prép for their
            <span className="italic text-[hsl(var(--primary))] font-medium"> lash lift.</span>
          </h2>
        </motion.div>

        {/* Bento reasons */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
          {REASONS.map((r, i) => {
            const span =
              i === 0 ? 'md:col-span-7' :
              i === 1 ? 'md:col-span-5' :
              i === 2 ? 'md:col-span-5' :
              'md:col-span-7';
            return (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.85, ease, delay: i * 0.08 }}
                className={`${span} luxe-hover-lift rounded-[1.5rem] border border-[hsl(var(--hairline))] p-9 lg:p-11 bg-[hsl(var(--cream-2))]/60 hover:bg-[hsl(var(--cream-2))]/90 transition-colors duration-700`}
              >
                <h3 className="font-display text-[1.4rem] lg:text-[1.7rem] tracking-tight leading-tight">
                  {r.title}
                </h3>
                <p className="mt-4 text-[hsl(var(--muted-foreground))] leading-[1.8] text-[0.95rem] lg:text-base">
                  {r.body}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Reviews */}
        <div className="mt-24 lg:mt-32 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9, ease }}
            className="lg:col-span-4"
          >
            <div className="text-overline mb-7">Real Reviews</div>
            <h3 className="font-display text-[1.8rem] lg:text-[2.5rem] tracking-tight leading-[1.1]">
              What our lash lift
              <span className="italic text-[hsl(var(--primary))] font-medium"> clients say.</span>
            </h3>
            <p className="mt-5 text-[0.95rem] text-[hsl(var(--muted-foreground))] leading-relaxed">
              Rated 5.0 / 5 from 3,500+ verified Fresha reviews and 400+ Google reviews.
            </p>
            <div className="mt-10 rounded-[1.5rem] overflow-hidden border border-[hsl(var(--hairline))] bg-[hsl(var(--secondary))] hidden lg:block luxe-shadow">
              <video
                src={VIDEOS.gallery[1].src}
                poster={VIDEOS.gallery[1].poster}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                className="w-full h-[400px] object-cover"
                data-testid="reviews-video"
              />
            </div>
          </motion.div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-7">
            {REVIEWS.map((r, i) => (
              <motion.figure
                key={i}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.7, ease, delay: i * 0.07 }}
                className="luxe-hover-lift rounded-[1.25rem] border border-[hsl(var(--hairline))] p-8 lg:p-9 bg-[hsl(var(--background))]"
              >
                <div
                  className="font-display text-[3.5rem] text-[hsl(var(--primary))] leading-none -mt-2 mb-2 italic"
                  aria-hidden
                >
                  &ldquo;
                </div>
                <blockquote className="font-display text-[1.1rem] lg:text-[1.2rem] leading-[1.55] tracking-tight italic text-[hsl(var(--foreground))]/90">
                  {r.quote}
                </blockquote>
                <figcaption className="mt-6 text-[0.62rem] uppercase tracking-[0.28em] text-[hsl(var(--muted-foreground))] font-light">
                  {r.name} · {r.meta}
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
